/* eslint-disable import/no-useless-path-segments */
/* eslint-disable no-param-reassign */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/named */
/* eslint-disable prefer-template */
/* eslint-disable one-var */
/* eslint-disable radix */
/* eslint-disable no-else-return */
/* eslint-disable no-shadow */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-var */
/* eslint-disable no-console */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-const */
/* eslint-disable dot-notation */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/no-array-index-key */

import React, { useState, useEffect, useRef } from 'react';
import axios from "axios";
import clsx from "clsx";
import moment from "moment";
import PropTypes, { object } from "prop-types";
import { connect, useDispatch, useSelector } from "react-redux";
import { IconButton } from '@mui/material';
import { UploadFile } from '@mui/icons-material';
import { Grid } from "@material-ui/core";
import { styled } from '@mui/material/styles';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Checkbox } from 'primereact/checkbox';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { withAllowedOperationsProvider } from '../../hocs';
import { Button, CustomTab } from "../../atomicComponents";
import MultiSelects from "../FormComponents/MultiSelects";
import {  MESSAGE_TYPE,  RESOURCE_TYPE} from "../../constants";
import { CustomFormGroup } from "../../components/FormComponents";
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import Truckloading from "../CvLoader/Cvloader";
import styles from './SAPDataReUploadReport.module.css'
import { sanitizeCoCodeNumeric, sanitizeNumeric } from '../../utils/utils';

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.primary.main, // Use theme colors
  backgroundColor: theme.palette.background.paper,
  borderRadius: '50%',
  padding: '10px',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}));

const SAPDataReUploadReport = ({baseUrl, auth}) => {

  let { userRole, personNumber, companyCode} = auth;
  const { showPopup } = usePopupManager();
  const inputRef = useRef(null);

  let firstDayOfMonth = moment().startOf('month').format('YYYY-MM-DD');
  let currentDate = moment().format('YYYY-MM-DD');

  const [loading, setLoading] = useState(false);
  const [checkedBtn, setCheckedBtn] = useState(false);
  const [checkboxLabel, setCheckboxLabel] = useState("by_job");
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [disableBtn, setDisableBtn] = useState(true);
  const [fromDate, setFromDate] = useState(firstDayOfMonth);
  const [toDate, setToDate] = useState(currentDate);
  const [tableData, setTableData] = useState([]);
  const [displayFile, setDisplayFile] = useState("none");
  const [submitBtn , setSubmitBtn] = useState(true);
  const [projDefArray, setProjDefArray] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [proDefDetails, setProDefDetails] = useState([]);
  const [selectOptions, setSelectOptions] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);

  const baseDefaultColumns = [
    {
      width: 40,
      textAlign: "left",
      title: 'Project Definition',
      field: 'project_def',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 70,
      textAlign: "left",
      title: 'Project Description',
      field: 'project_description',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 40,
      textAlign: "left",
      title: 'Sum of failure hrs',
      field: 'sap_hrs',
      enableSearch: true,
      enableFilter: true,
    },
   ];

  const getSAPData = () => {
    const apiFormatedData = {
      pers_no: sanitizeNumeric(personNumber),
      co_code: sanitizeCoCodeNumeric(companyCode),
      pers_roles: userRole,
      from_date: fromDate,
      to_date: toDate,
    };

    var apiFormatedDataJson = JSON.stringify(apiFormatedData);
    let headerss = new Headers();  
    headerss.append("Content-Type", "application/json");
    fetch(`${baseUrl}reports/FetchSAPHoursPostingErrors`, {
      method: "POST",
      headers: headerss,
      credentials:'include',
      body: apiFormatedDataJson
    })
      .then((response) => response.json())
      .then((responseJson) => {
        setTableData(responseJson.data);
        setFilterData(responseJson.data);

        const sortedData = responseJson.data.filter(row => row.sap_hrs !== "Hours Mismatch");

        const selectOptionArray = [];
        sortedData.map((row) => {
          selectOptionArray.push({
            label: row.project_def,
            value: row.project_def,
          });
        });

          let jsonObject = selectOptionArray.map(JSON.stringify);
          let uniqueSet = new Set(jsonObject);
          let uniqueArray = Array.from(uniqueSet).map(JSON.parse);
          setSelectOptions(uniqueArray);

      })
      .catch((error) => {console.log("error---> ", error)});
  };

  useEffect(()=>{
      getSAPData();
  },[]);

  useEffect(()=>{

   if (inputRef == null) {
      setSelectedFile(null);
      setFileName("");
    }

    if(selectedData.length <= 0){
      setDisableBtn(true);
      setDisplayFile("none");
      setSubmitBtn(true);
      setCheckedBtn(false);
    }
    else{
      const newArray = selectedData.map(project => project.project_def);
      setProjDefArray(newArray);
    }

    if(fileName !== ""){
      setSubmitBtn(false);
    }

  },[selectedData,fileName]);

  const handleSaveSAPData = () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("pers_no", sanitizeNumeric(personNumber));
    formData.append("co_code", sanitizeCoCodeNumeric(companyCode));
    formData.append("pers_roles", JSON.stringify(userRole));
    formData.append("from_date", fromDate);
    formData.append("to_date", toDate);
    formData.append("reposting_errors", JSON.stringify(projDefArray));
    formData.append("flag", checkboxLabel);
    formData.append("attachment", selectedFile);
    let headerss = new Headers();
    fetch(`${baseUrl}reports/SAPHoursPostingErrors`, {
      method: "POST",
      headers: headerss,
      credentials:'include',
      body: formData
    })
      .then((response) => response.json())
      .then((responseJson) => {
        setLoading(false);
      if(responseJson.msg === "Success"){
          let msg = `${responseJson.data} Request Id Gernerated.`;
          let final_msg = checkboxLabel === "by_script" ?  msg : responseJson.data;
          showPopup({
            type: MESSAGE_TYPE.SUCCESS,
            contextText: MESSAGE_TYPE.SUCCESS,
            info: final_msg,
            reloads: true
          });
      }
      else{
        showPopup({
          type: MESSAGE_TYPE.FAILURE,
          contextText: MESSAGE_TYPE.FAILURE,
          info: "Something Went Wrong",
        });

      }
      
      })
      .catch((error) => {
        setLoading(false);
        console.log("error---> ", error)
      });

  };
  
  const handleFileChange = (e) => {
    var FileUploadCtrl = e.target.files[0];
    if(FileUploadCtrl == undefined || FileUploadCtrl == ''){
    showPopup({
      type: MESSAGE_TYPE.INFORMATION,
      contextText: MESSAGE_TYPE.INFORMATION,
      info: "Please select File",
    });
    inputRef.current.value = null;
    setSelectedFile(null);
    setFileName("");
    }
    else{
    var FilePath = FileUploadCtrl.name;
    // console.log("FilePath....",FilePath)
    var Ext = FilePath.substring(FilePath.lastIndexOf('.') + 1).toLowerCase();
    if (Ext !== "msg")
    {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please select msg / mail File type",
      });
      inputRef.current.value = null;
      setSelectedFile(null);
    }  
    else{
      if (FilePath) {
        setFileName(FilePath); // Update file name
      }
      setSelectedFile(e.target.files[0]);
    }
  }
  };
  
  const onCheckedChange = (e) => {
    const checkedVal = e.target.checked;

    if(checkedVal){
      setDisplayFile("block");
      setCheckboxLabel('by_script');
      setSubmitBtn(true);
    }else{
      setDisplayFile("none");
      setCheckboxLabel('by_job');
      setSubmitBtn(false);
    }
    setCheckedBtn(checkedVal);
    setDisableBtn(false);
   
  }

  const onCheckboxChange = (rowData, checked) => {
    let newSelectedData;
    if (checked) {
      // Add rowData to selectedData if checked
      newSelectedData = [...selectedData, rowData];
      setDisableBtn(false);
    } else {
      // Remove rowData from selectedData if unchecked
      newSelectedData = selectedData.filter(item => item.project_def !== rowData.project_def);
    }
    setSelectedData(newSelectedData);
    setSubmitBtn(false);
  };
  
  const checkboxBodyTemplate = (rowData) => {
    const isDisabled = rowData.sap_hrs === "Hours Mismatch"; // Disable if sap_hrs is "Hours Mismatch"
    const isChecked = selectedData.some(item => item.project_def === rowData.project_def); // Check if this row is selected

    return (
        <input 
            type="checkbox" 
            disabled={isDisabled} 
            checked={isChecked}
            onChange={(e) => onCheckboxChange(rowData, e.target.checked)}
        />
    );
  };

  const onSelectAllChange = (e) => {
    const checked = e.target.checked;
    setSelectAllChecked(checked);
    
    if (checked) {
        const allRows = filterData.filter(row => row.sap_hrs !== "Hours Mismatch"); // Filter out disabled rows
        setSelectedData(allRows);
    } else {
        setSelectedData([]);
    }

    setDisableBtn(false);
    setSubmitBtn(false);
  };

const isAllSelected = filterData.every(row => {
  const isDisabled = row.sap_hrs !== "Hours Mismatch";
  return isDisabled || selectedData.some(item => item.project_def === row.project_def);
});

  const renderTable = () => (
    <>
      <div className="card" style={{ height: "250px !important"}}>
        <div className={clsx(styles.scrollBarTable)}>
            <DataTable
              value={filterData}
              selection={selectedData}
              selectionMode="checkbox"
              scrollable
              scrollHeight="250px"
              className={styles.tableCss}
              style={{maxWidth: '101%', fontSize: "14px" }}
              resizableColumns
              paginator 
              rows={10} 
              rowsPerPageOptions={[5, 10, 25, 50]}
              size={'small'}
              showGridlines 
            >
              <Column 
                  body={checkboxBodyTemplate} 
                  header={<sapn><input type="checkbox" checked={selectAllChecked} onChange={onSelectAllChange}/> 
                  {/* header={<sapn><input type="checkbox" checked={isAllSelected} onChange={onSelectAllChange}/>  */}
                  <label style={{ fontSize: '14px', fontWeight: '500', color: '#495057'}}>Select All</label></sapn>} 
                  style={{ textAlign: 'center' , width: '20px'}} 
                  headerStyle={{ width: '2em' }} 
              />
              {baseDefaultColumns.map((column, index) => (
                <Column
                  key={index}
                  field={column.field}
                  header={column.title}
                  style={{ width: column.width}}
                  className={styles.columCss}
                />
              ))}

            </DataTable>
        </div>
      </div>
    </>

)

const handleSelectChange = (selectedOption) => {
  setProDefDetails(selectedOption);
  const displayData = selectedOption.map(item => item.value);

    if(selectedOption.length >= 1){
      const filteredData = tableData.filter(item => displayData.includes(item.project_def));
      setFilterData(filteredData);
    }
    else{
      setFilterData(tableData);
    }
};

const renderProjectDefination = () => {
  return (
    <Grid
      container
      spacing={1}
      direction="row"  
      className={styles.myGrid}
      style={{paddingTop: '10px'}}     
    >
      <Grid item md={2} lg={2} xs={2}>
      <label htmlFor="ingredient4" className={styles.labelText}>Project Defination: </label>
      </Grid>
      <Grid item md={2} lg={2} xs={3}>
        <MultiSelects
          isMulti
          isClearable
          value={proDefDetails}
          options={selectOptions}
          onChange={handleSelectChange}
          style={{width: '70%'}}
          name="Project_def"
        />
      </Grid>
    </Grid>
  );
};

const renderCheckBox = () => (
  <Grid
      container
      spacing={1}
      direction="row"
      className={styles.checkBoxGrid}        
    >
      <Grid item md={3} lg={3} xs={3}>
        <Checkbox 
          onChange={onCheckedChange} 
          checked={checkedBtn}
          disabled={disableBtn}
        />
        <label htmlFor="ingredient4" className={styles.labelText}>Immediate Transfer To SAP</label>
      </Grid>
      <Grid item md={4} lg={4} xs={2}>
        <div style={{ display: displayFile}}>
          <input
            type="file"
            style={{ display: 'none' }}
            ref={inputRef}
            onChange={(e) => {
              handleFileChange(e);
            }}
            id="file-upload"
            data-testid="uploadFile"
            accept=".msg"
            required
          />
          <label htmlFor="file-upload">
            <span className={styles.labelText}> Upload Approval Mail </span>
            <StyledIconButton component="span">
              <UploadFile />
            </StyledIconButton >
          </label>
          <span className={styles.fileLabelText}>{fileName ? fileName : ""}</span>
        </div>

      </Grid>
      <Grid item md={2} lg={2} xs={2}>
          <Button
              className={clsx(styles.actionButton)}
              variant="primary"
              onClick={() => handleSaveSAPData()}
              data-testid="confirm-action"
              disabled={submitBtn}
          >
              Transfer To SAP
          </Button>
      </Grid>
  </Grid>
);

  return (
    <>
      <div className={styles.formContainer}>
        <CustomFormGroup header='Manual SAP Posting' 
          body={renderProjectDefination()} 
          />
          {renderTable()}
          {renderCheckBox()}
         {
          loading ? (
            <div style={{textAlign:"center",display:"flex",justifyContent:"center",marginTop:"40px"}}>
                 <Truckloading />
              </div>):""
         }

      </div>
      </>
   
  );
};

const mapStateToProps = (state) => ({
  baseUrl: state.counter.baseUrl,
  auth: state.auth,
});

SAPDataReUploadReport.propTypes = {
  baseUrl: PropTypes.string,
  auth: PropTypes.object,
};
const App = connect(mapStateToProps)(SAPDataReUploadReport);

export default withAllowedOperationsProvider(App, RESOURCE_TYPE.PPAP);

